import React from "react";
import * as Icon from "react-bootstrap-icons";
import avatar from "../images/admin-avatar-1.jpg";
import {confirmAlert} from "react-confirm-alert";
import * as Utils from "./Utils";
import { NavLink, Link} from "react-router-dom";
import logo from "../images/logo.png";
import Role from "./Role";

export default function Header() {
    const roles = new Role();
    let fullName = roles.loginName;
    let url = window.location.pathname;

    const signOut = () => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการออกจากระบบ ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: () => {
                        localStorage.removeItem(Utils.LOCAL_STORAGE_KEY);
                        window.location.href = '/';
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    let [showSideBar, setSideBar] = React.useState(true);

    const onClickSideBar = () => {
        setSideBar(!showSideBar);
    };

    return (
        <>
        <div id="sidebarMenu" className={showSideBar ? 'sidebar show':'sidebar'}>
            <div className="side-brand">
                <img src={logo} height="36" alt="" />
                <span className="fw-bold text-danger small">Social Tag Management</span>
            </div>

            {roles.isView(Utils.MENU_CAMPAIGN_TEMPLATE) || roles.isView(Utils.MENU_GENERATE_PROJECT) || roles.isView(Utils.MENU_GENERATE_PROMOTION) || roles.isView(Utils.MENU_GENERATE_SPECIAL) || roles.isView(Utils.MENU_GENERATE_MASTER_URL) ? (
                <>
                    <h6><Icon.Fire /> <span>Smart Generate (Ads & UTM)</span></h6>
                    <ul className="nav flex-column">
                        {roles.isView(Utils.MENU_CAMPAIGN_TEMPLATE) ? (
                            <li className="nav-item"><NavLink to='/campaignTemplate' className={url.indexOf('/campaignTemplate') > 0 ? 'nav-link active':'nav-link'}><span>Campaign Template</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_GENERATE_PROJECT) ? (
                            <li className="nav-item"><NavLink to='/generateProject' className={url.indexOf('/generateProject') > 0 ? 'nav-link active':'nav-link'}><span>Generate Project</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_GENERATE_PROMOTION) ? (
                            <li className="nav-item"><NavLink to='/generatePromotion' className={url.indexOf('/generatePromotion') > 0 ? 'nav-link active':'nav-link'}><span>Generate Promotion</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_GENERATE_SPECIAL) ? (
                            <li className="nav-item"><NavLink to='/generateSpecial' className={url.indexOf('/generateSpecial') > 0 ? 'nav-link active':'nav-link'}><span>Generate Special</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_GENERATE_MASTER_URL) ? (
                            <li className="nav-item"><NavLink to='/generateMasterURL' className={url.indexOf('/generateMasterURL') > 0 ? 'nav-link active':'nav-link'}><span>Generate Master URL</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_GENERATE_GROUP) ? (
                            <li className="nav-item"><NavLink to='/generateGroup' className={url.indexOf('/generateGroup') > 0 || url.indexOf('generateGroupCampaign') > 0 ? 'nav-link active':'nav-link'}><span>Group</span></NavLink></li>
                        ) : ''}
                    </ul>
                </>
            ) : ''}
            {roles.isView(Utils.MENU_UTM_TEMPLATE) || roles.isView(Utils.MENU_UTM_GROUP) || roles.isView(Utils.MENU_UTM_GENERATE) || roles.isView(Utils.MENU_UTM) || roles.isView(Utils.MENU_MASTER_URL) ? (
                <>
                    <h6><Icon.Lightbulb /> <span>UTM</span></h6>
                    <ul className="nav flex-column">
                        {roles.isView(Utils.MENU_UTM_TEMPLATE) ? (
                            <li className="nav-item"><NavLink to='/utmTemplate' className={url.indexOf('/utmTemplate') > 0 ? 'nav-link active':'nav-link'}><span>Template</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_UTM_GROUP) ? (
                            <li className="nav-item"><NavLink to='/utmGroup' className={url.indexOf('/utmGroup') > 0 || url.indexOf('/utmGroupItem') > -1 ? 'nav-link active':'nav-link'}><span>Group</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_UTM_GENERATE) ? (
                            <li className="nav-item"><NavLink to='/utmGenerate' className={url.indexOf('/utmGenerate') > 0 ? 'nav-link active':'nav-link'}><span>Generate UTM</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_UTM) ? (
                            <li className="nav-item"><NavLink to='/utm' className={url.indexOf('/utm') > 0 || url.indexOf('/utmSource') > -1 || url.indexOf('/utmSourceType') > -1 || url.indexOf('/utmExport') > -1 ? 'nav-link active':'nav-link'}><span>Master UTM Format</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_MASTER_URL) ? (
                            <li className="nav-item"><NavLink to='/masterUrl' className={url.indexOf('/masterUrl') > 0 ? 'nav-link active':'nav-link'}><span>Master URL</span></NavLink></li>
                        ) : ''}
                    </ul>
                </>
            ) : ''}

            {roles.isView(Utils.MENU_ADSNAMING_GENERATE) || roles.isView(Utils.MENU_ADSNAMING ) || roles.isView(Utils.MENU_CONTENT_PILLAR || roles.isView(Utils.MENU_KOL) || roles.isView(Utils.MENU_ADSNAMING_SETNAME_TYPE)) ? (
                <>
                    <h6><Icon.Gem /> <span>Ads Naming</span></h6>
                    <ul className="nav flex-column">
                        {roles.isView(Utils.MENU_ADSNAMING_GENERATE) ? (
                            <li className="nav-item"><NavLink to='/adsCampaignGroup' className={url.indexOf('/adsCampaignGroup') > 0 || url.indexOf('/adsCampaignGroupItem') > -1 ? 'nav-link active':'nav-link'}><span>Campaign Naming Group</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_ADSNAMING_GENERATE) ? (
                            <li className="nav-item"><NavLink to='/adsSetNameGroup' className={url.indexOf('/adsSetNameGroup') > 0 || url.indexOf('/adsSetnameGroupItem') > -1 ? 'nav-link active':'nav-link'}><span>Ads Set Naming Group</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_ADSNAMING_GENERATE) ? (
                            <li className="nav-item"><NavLink to='/adsNamingCampaign' className={url.indexOf('/adsNamingCampaign') > 0 ? 'nav-link active':'nav-link'}><span>Generate Campaign Naming</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_ADSNAMING_GENERATE) ? (
                            <li className="nav-item"><NavLink to='/adsNamingSetName' className={url.indexOf('/adsNamingSetName') > 0 ? 'nav-link active':'nav-link'}><span>Generate Ads Set Naming</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_ADSNAMING_GENERATE) ? (
                            <li className="nav-item"><NavLink to='/adsNamingCreativeAlways' className={url.indexOf('/adsNamingCreativeAlways') > 0 || url.indexOf('/adsNamingCreativeBoostpost') > -1 || url.indexOf('/adsNamingCreativeKol') > -1 ? 'nav-link active':'nav-link'}><span>Generate Creative Naming</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_CONTENT_PILLAR) ? (
                            <li className="nav-item"><NavLink to='/adsNamingContentPillar' className={url.indexOf('/adsNamingContentPillar') > 0 ? 'nav-link active':'nav-link'}><span>Content Pillar</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_ADSNAMING) ? (
                            <li className="nav-item"><NavLink to='/adsNaming' className={url.indexOf('/adsNaming') > 0 || url.indexOf('/adsNamingSource') > -1 ? 'nav-link active':'nav-link'}><span>Master Ads Naming Format</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_KOL) ? (
                            <li className="nav-item"><NavLink to='/adsNamingKol' className={url.indexOf('/adsNamingKol') > 0 ? 'nav-link active':'nav-link'}><span>Kol Page Setup</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_ADSNAMING_SETNAME_TYPE) ? (
                            <li className="nav-item"><NavLink to='/adsNamingSetNameType' className={url.indexOf('/adsNamingSetNameType') > 0 ? 'nav-link active':'nav-link'}><span>Set Name Type</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_ADS_PLATFORM) ? (
                            <li className="nav-item"><NavLink to='/adsPlatform' className={url.indexOf('/adsPlatform') > 0 ? 'nav-link active':'nav-link'}><span>Master Platform</span></NavLink></li>
                        ) : ''}
                    </ul>
                </>
            ) : ''}

            {roles.isView(Utils.MENU_LEAD_FORM_PROJECT) || roles.isView(Utils.MENU_LEAD_FORM_CAMPAIGN) ? (
                <>
                    <h6><Icon.Box /> <span>Lead Form</span></h6>
                    <ul className="nav flex-column">
                        {roles.isView(Utils.MENU_LEAD_FORM_PROJECT) ? (
                            <li className="nav-item"><NavLink to='/leadFormProject' className={url.indexOf('/leadFormProject') > 0 || url.indexOf('/leadFormProject') > -1 ? 'nav-link active':'nav-link'}><span>Lead Form Project</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_LEAD_FORM_CAMPAIGN) ? (
                            <li className="nav-item"><NavLink to='/leadFormCampaign' className={url.indexOf('/leadFormCampaign') > 0 || url.indexOf('/leadFormCampaign') > -1 ? 'nav-link active':'nav-link'}><span>Lead Form Campaign</span></NavLink></li>
                        ) : ''}
                    </ul>
                </>
            ) : ''}

            {roles.isView(Utils.MENU_CONTENT_ID) || roles.isView(Utils.MENU_CONTENT_CHANEL) || roles.isView(Utils.MENU_CONTENT_CATEGORY) || roles.isView(Utils.MENU_CONTENT_BG) || roles.isView(Utils.MENU_CONTENT_CAMPAIGN_TYPE) ? (
                <>
                    <h6><Icon.Star /> <span>Content ID</span></h6>
                    <ul className="nav flex-column">
                        {roles.isView(Utils.MENU_CONTENT_ID) ? (
                        <li className="nav-item"><NavLink to='/contentId' className={url.indexOf('/contentId') > 0 ? 'nav-link active':'nav-link'}><span>Content ID</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_CONTENT_ID) ? (
                            <li className="nav-item"><NavLink to='/ownerRunningCode' className={url.indexOf('/ownerRunningCode') > 0 ? 'nav-link active':'nav-link'}><span>Content ID (Running No.)</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_CONTENT_CHANEL) ? (
                            <li className="nav-item"><NavLink to='/chanel' className={url.indexOf('/chanel') > 0 ? 'nav-link active':'nav-link'}><span>Channel</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_CONTENT_CATEGORY) ? (
                            <li className="nav-item"><NavLink to='/contentCategory' className={url.indexOf('/contentCategory') > 0 ? 'nav-link active':'nav-link'}><span>Content Category</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_CONTENT_BG) ? (
                            <li className="nav-item"><NavLink to='/bg' className={url.indexOf('/bg') > 0 ? 'nav-link active':'nav-link'}><span>BG</span></NavLink></li>
                        ) : ''}
                        {roles.isView(Utils.MENU_CONTENT_CAMPAIGN_TYPE) ? (
                            <li className="nav-item"><NavLink to='/campaignType' className={url.indexOf('/campaignType') > 0 ? 'nav-link active':'nav-link'}><span>Product Type</span></NavLink></li>
                        ) : ''}
                    </ul>
                </>
            ) : ''}

            {roles.isView(Utils.MENU_HASTAG) || roles.isView(Utils.MENU_SETTING_AGENCY) || roles.isView(Utils.MENU_SETTING_OWNER) || roles.isView(Utils.MENU_SETTING_PERMISSION) || roles.isView(Utils.MENU_SETTING_USER) || roles.isView(Utils.MENU_REBRANDLY) || roles.isView(Utils.MENU_SHORTIO) || roles.isView(Utils.MENU_QRCODE_LOGO) || roles.isView(Utils.MENU_AWS_S3) || roles.isView(Utils.MENU_LANG) || roles.isView(Utils.MENU_BU_TYPE) || roles.isView(Utils.MENU_PROJECT_TYPE) || roles.isView(Utils.MENU_AWS_S3_EXPORT) ? (
            <>
            <h6><Icon.Gear /> <span>Setting</span></h6>
            <ul className="nav flex-column mb-3">
                {roles.isView(Utils.MENU_HASTAG) ? (
                    <li className="nav-item"><NavLink to='/hashtag' className={url.indexOf('/hashtag') > 0 ? 'nav-link active':'nav-link'}><span>Hash Tag</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_SETTING_AGENCY) ? (
                    <li className="nav-item"><NavLink to='/agency' className={url.indexOf('/agency') > 0 ? 'nav-link active':'nav-link'}><span>Agency</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_SETTING_OWNER) ? (
                    <li className="nav-item"><NavLink to='/owner' className={url.indexOf('/owner') > 0 ? 'nav-link active':'nav-link'}><span>Owner</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_SETTING_PERMISSION) ? (
                    <li className="nav-item"><NavLink to='/permission' className={url.indexOf('/permission') > 0 ? 'nav-link active':'nav-link'}><span>Permission</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_SETTING_USER) ? (
                    <li className="nav-item"><NavLink to='/user' className={url.indexOf('/user') > 0 ? 'nav-link active':'nav-link'}><span>Users</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_REBRANDLY) ? (
                    <li className="nav-item"><NavLink to='/rebrandly' className={url.indexOf('/rebrandly') > 0 ? 'nav-link active':'nav-link'}><span>Rebrandly</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_SHORTIO) ? (
                    <li className="nav-item"><NavLink to='/shortio' className={url.indexOf('/shortio') > 0 ? 'nav-link active':'nav-link'}><span>Short.io</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_QRCODE_LOGO) ? (
                    <li className="nav-item"><NavLink to='/qrcodeLogo' className={url.indexOf('/qrcodeLogo') > 0 ? 'nav-link active':'nav-link'}><span>QR Code Logo</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_AWS_S3) ? (
                    <li className="nav-item"><NavLink to='/awsS3' className={url.indexOf('/awsS3') > 0 ? 'nav-link active':'nav-link'}><span>AWS S3</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_AWS_S3_EXPORT) ? (
                    <li className="nav-item"><NavLink to='/awsS3Export' className={url.indexOf('/awsS3Export') > 0 ? 'nav-link active':'nav-link'}><span>AWS S3 Export Data</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_LANG) ? (
                    <li className="nav-item d-none"><NavLink to='/lang' className={url.indexOf('/lang') > 0 ? 'nav-link active':'nav-link'}><span>Language</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_BU_TYPE) ? (
                    <li className="nav-ite d-none"><NavLink to='/buType' className={url.indexOf('/buType') > 0 ? 'nav-link active':'nav-link'}><span>Bu Type</span></NavLink></li>
                ) : ''}
                {roles.isView(Utils.MENU_PROJECT_TYPE) ? (
                    <li className="nav-item d-none"><NavLink to='/projectType' className={url.indexOf('/projectType') > 0 ? 'nav-link active':'nav-link'}><span>Project Type</span></NavLink></li>
                ) : ''}
            </ul>
            </>
            ) : ''}
        </div>
        <header className="sticky-top shadow">
            <div className="row flex-nowrap justify-content-between align-items-center">
                <div className="col-4">
                    <div  className={showSideBar ? 'navbar-brand show':'navbar-brand'}>
                        <button type="button" className="btn btn-sm btn-light align-self-center me-2" onClick={onClickSideBar}><Icon.List /></button>
                        <div className={showSideBar ? 'd-none':'d-inline-block'}>
                            <img src={logo} height="36" alt="" />
                            <span className="fw-bold text-danger small">Social Tag Management</span>
                        </div>
                    </div>
                </div>
                <div className="col-4 d-flex justify-content-end align-items-center">
                    <div className="dropdown">
                        <button type="button" className="btn btn-light p-1 dropdown-toggle" id="dropdownMenuLink"
                        data-bs-toggle="dropdown" aria-expanded="false">
                            <img src={avatar} width="24" alt="" className="rounded-circle" /> <span className="small text-muted">Hi, {fullName}</span>
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <li><Link className="dropdown-item" to='/profile'>Edit Profile</Link></li>
                            <li><Link className="dropdown-item" to='/changepw'>Change Password</Link></li>
                            <li><Link className="dropdown-item" to='' onClick={signOut}>Sign out</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
        </>
    );
} 